import { navLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-900 py-14 text-secondary-100">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">我的家庭教师</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-7 text-secondary-100/75">
              一个围绕《我的家庭教师》的独立解析站，专注于剧情脉络梳理、角色背景介绍与结局讨论，帮助新老观众更清晰地理解整个故事。
            </p>
          </div>

          <div className="lg:col-span-3">
            <h3 className="font-heading text-sm font-bold text-background-50">页面导航</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a href={link.href} className="text-sm text-secondary-100/75 transition-colors hover:text-primary-300">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <h3 className="font-heading text-sm font-bold text-background-50">阅读提示</h3>
            <p className="mt-4 text-sm leading-7 text-secondary-100/75">
              本站内容为观众视角的作品解析与讨论，不代表官方立场。作品名称、角色及相关设定的一切权利归原作者与出版方所有。文中涉及剧情的信息以作品已呈现的内容为准，未明确交代的部分仅作一般性说明。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-secondary-100/60">© 2026 我的家庭教师解析站 · 观众向非官方解析内容</p>
          <a href="#top" className="inline-flex items-center gap-1.5 text-xs text-secondary-100/70 transition-colors hover:text-primary-300">
            回到顶部
            <i className="ri-arrow-up-line" />
          </a>
        </div>
      </div>
    </footer>
  );
}